import React, { Component, Fragment } from "react";
import { FaPlusCircle, FaSearch } from "react-icons/fa";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import {
  Button,
  Col,
  Container,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Alert,
} from "shards-react";
import { TilesComponent } from "../../../common/dashboard/TilesComponent/TilesComponent";
import LoadingComponent from "../../../common/loading/LoadingComponent";
import { closeModal, openModal } from "../../../common/modals/modalActions";
import {
  isNewUser,
  updateLastLogin,
  updateProfile,
} from "../UpdateProfile/profileActions";
import {
  createComplaint,
  sendEmail,
  updateComplaint,
} from "./complaintActions";
import ComplaintList from "./ComplaintList/ComplaintList";
import { userComplaintsQuery } from "./userQueries";

const mapState = (state) => ({
  auth: state.firebase.auth,
  firebase: state.firebase,
  profile: state.firebase.profile,
  loading: state.async.loading,
  progress: [],
  complaints: state.firestore.ordered.complaints || [],
});

const actions = {
  createComplaint,
  updateComplaint,
  openModal,
  closeModal,
  sendEmail,
  updateProfile,
  isNewUser,
  updateLastLogin,
};

class ComplaintsDashboard extends Component {
  state = {
    filteredList: [],
    search: "",
    connectionStatus: "ok",
    complaints: [],
  };
  componentDidMount() {
    //check for internet speed
    let internetOk = navigator.onLine ? "online" : "offline";

    var connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    var type = connection?.effectiveType;

    console.log("Connection is" + type);

    if (internetOk === "offline") {
      this.setState({ connectionStatus: "poor" });
    }

    if (
      (window.navigator.connection !== null && type === "2g") ||
      (window.navigator.connection !== null && type === "slow-2g")
    ) {
      this.setState({ connectionStatus: "poor" });
      setTimeout(() => {
        this.checkNewUser();
      }, 10000);
    } else {
      setTimeout(() => {
        this.checkNewUser();
      }, 6000);
    }
  }

  checkNewUser() {
    //console.log(this.props.profile.isNewUser);
    if (this.props.profile.isNewUser || this.props.profile.profileIsEmpty) {
      this.props.openModal("WelcomeModal", {
        history: this.props.history,
        closeModal: this.props.closeModal,
        updateProfile: this.props.updateProfile,
        isNewUser: this.props.isNewUser,
        user: this.props.profile,
      });
    }
  }

  handleDeleteComplaint = (id) => {};

  handleUpdateComplaint = (updatedComplaint) => {};

  filterList = (event) => {
    let items = this.props.complaints.filter(
      (complaint) => complaint.status !== "closed"
    );
    if (event.target.value !== undefined || event.target.value !== "") {
      items = items.filter(function (item) {
        if (item.tags && item.tags.length > 0) {
          let keys = item.tags;

          if (event.target.value !== "" && keys && keys.length > 0) {
            for (const key of keys) {
              if (
                key.toLowerCase().search(event.target.value.toLowerCase()) !==
                -1
              ) {
                //console.log(`match ${key} - ${event.target.value}`);
                return true;
              }
            }
          }
        } else {
          return {};
        }
        return;
      });
    } else {
      items = this.props.complaints;
    }
    this.setState({ filteredList: items });
  };

  handleNewComplaint = () => {
    if (this.props.profile.profileIsEmpty) {
      //console.log('open');
      this.props.openModal("ProfileNotification", {
        history: this.props.history,
        closeModal: this.props.closeModal,
      });
    }

    if (!this.props.profile.isNewUser && !this.props.profile.profileIsEmpty) {
      this.props.openModal("NewComplaintModal", {
        handleFileUpload: this.handleFileUpload,
      });
    }
  };

  render() {
    let { history, profile, complaints } = this.props;
    const { filteredList, connectionStatus } = this.state;

    if (!isLoaded(complaints)) return <LoadingComponent loading={true} />;

    if (profile.role === "agent" || profile.role === "temp-agent") {
      let filteredComplaints = this.props.complaints.filter(
        (complaint) =>
          complaint.agent.uid === this.props.auth.uid ||
          complaint.agent.email === this.props.auth.email
      );
      complaints = filteredComplaints;
    }

    return (
      <Container fluid className="h-100 my-3">
        {connectionStatus === "poor" ? (
          <div className="alert">
            You have a poor connection. In case the dashboard does not load on
            the first time, please refresh the page.
          </div>
        ) : (
          ""
        )}
        {/* prevent agents from using test site */}

        {process.env.NODE_ENV !== "production" && (
          <Alert className="alert alert-primary">
            This is a test site. Please use the main site at {"   "}
            <a className="custom-link" href="https://ncccaduan.firebaseapp.com">
              NCCC Site
            </a>
          </Alert>
        )}
        <h5 className="text-capitalize">{profile.role} Dashboard</h5>
        <div className="tiles">
          <TilesComponent complaints={complaints} />
        </div>
        <Fragment>
          <Col>
            <InputGroup>
              <InputGroupAddon type="prepend">
                <InputGroupText>
                  <FaSearch />
                </InputGroupText>
              </InputGroupAddon>
              <FormInput
                type="text"
                placeholder="Search"
                onChange={(e) => this.setState({ search: e.target.value })}
                onKeyDown={this.filterList}
                value={this.state.search}
              />
            </InputGroup>
          </Col>

          {complaints &&
          complaints.filter((complaint) => complaint.status !== "closed")
            .length > 0 ? (
            <ComplaintList
              complaints={
                this.state.search !== ""
                  ? filteredList
                  : complaints.filter(
                      (complaint) => complaint.status !== "closed"
                    )
              }
              history={history}
              archive={false}
              handleNewComplaint={this.handleNewComplaint}
            />
          ) : (
            <Fragment>
              No Complaints Yet.
              {profile.profileIsEmpty ? (
                <div className="text-danger">
                  Please fill up the Profile before submitting a complaint. Go
                  to{" "}
                  <a
                    className="text-primary"
                    onClick={() => history.push("/dashboard/profile")}
                  >
                    Profile Page
                  </a>
                </div>
              ) : (
                <span> Click Add button to start adding a complaint.</span>
              )}
              {profile.role === "complainant" ? (
                <Button
                  onClick={this.handleNewComplaint}
                  className="align-content-center float-right my-2"
                  disabled={profile.profileIsEmpty}
                >
                  <FaPlusCircle className="mr-2" />
                  <span>Add</span>
                </Button>
              ) : (
                ""
              )}
            </Fragment>
          )}
        </Fragment>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firestoreConnect((auth, profile) => userComplaintsQuery(auth, profile))
)(ComplaintsDashboard);
